import React from 'react'
import { useTypewriter, Cursor } from 'react-simple-typewriter'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import Circles from './Circles'
import { FaGithub, FaInstagram, FaLinkedin } from 'react-icons/fa';
import profile from './pp1.png'  

const Hero = () => {
  const [text] = useTypewriter({
    words: ['am a Frontend Enthusiast', 'Love to <Code/>'],
    loop: 0
  })
  return (
    
      <motion.div
    initial={{ y: 600 }}
          animate={{ y: 0,
            transition: { duration: 0.5, ease: 'easeOut' } }}
    class="flex flex-col sm:flex-row h-auto mt-10 mb-16">
      <div class="flex justify-center items-center h-5/6 w-full sm:w-1/2 md:w-full p-6">
        <div class="flex flex-col justify-center items-center w-full">
          <div className='flex flex-col md:mr-72 lg:mr-72 xl:mr-72'>
            <div class="h-16 w-64 text-left font-bold tracking-widest text-transparent text-3xl bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 ">Hi there!, I'm </div>
            <div class="h-16 w-64 text-left font-bold tracking-widest text-transparent text-3xl bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 ">Bibek Jha</div>
          </div>
          <div class="h-24 w-full justify-center flex"><span className='h-24 w-3/4 text-left font-bold tracking-widest text-transparent text-3xl bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 '>I {text} <Cursor cursorColor='yellow' /></span>
          </div>
          <div className='font-mono mt-4 pl-8'>
            <p className='text-slate-400 text-justify tracking-wider'>I am a Frontend Developer specializing in creating engaging user experiences using Library like ReactJS and React Native. With expertise in HTML5, CSS, and Tailwind CSS, I translate designs into visually stunning and responsive websites. I stay up-to-date with the latest frontend technologies and collaborate effectively with designers and developers to deliver outstanding results. Committed to delivering high-quality code and seamless user experiences, I am excited about pushing the boundaries of web and mobile development using my expertise.</p>
          </div>
        </div>



      </div>
      
      <div class="mt-40 flex justify-center items-center h-5/6 w-full sm:w-1/2 md:w-full p-6">
        <Circles className="mb-10"/>
        <h2 className='absolute mt-60 font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-pink-400 to-red-700 hover:bg-gradient-to-r   ' >Reach Me Out on:</h2>


        <img className='h-32 w-32 rounded-full absolute mx-auto mt-52 md:mt-2 lg:mt-0 xl:mt-0 ' src={profile} alt='pp'/>
        
        <div className='absolute w-1/3 h-24 mt-96 flex justify-around'>
          
        <Link to="https://github.com/Bib3k4u" className='font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700'>
            <FaGithub className='text-yellow-400 bg-[#1A1A1A] rounded-full h-10 w-10 hover:bg-[#3A3A3A]  '/>
          </Link>
          <Link to="https://www.linkedin.com/in/bibek-jha-3396b4218/" className='font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700'>
            <FaLinkedin className='text-yellow-400 bg-[#1A1A1A] rounded-lg h-10 w-10 hover:bg-[#3A3A3A] '/>
          </Link>
          <Link to="https://instagram.com/_zha_bibek_?igshid=MzNlNGNkZWQ4Mg==" className='font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700'>
            <FaInstagram className='text-yellow-400 bg-[#1A1A1A] rounded-full h-10 w-10 hover:bg-[#3A3A3A]'/>
          </Link>
          
          
          
        </div>
      </div>
    </motion.div>

   
  )
}

export default Hero